module.exports = __webpack_public_path__ + "img/briefing-1.2da8811a.jpg";